/**
 * LayoutInput class
 * 
 * Represents a configurable input for widgets.
 * Similar to IntegrationInput in the Command System.
 */
class LayoutInput {
  constructor(name, type, label = '', defaultValue = null, advancedType = '', options = []) {
    this.name = name;
    this.type = type;
    this.options = options;
    this.label = label;
    this.required = false;
    this.defaultValue = defaultValue;
    this.value = defaultValue;
    this.isAdvanced = false;
    
    if(advancedType === 'map') this.isMap = true;
    else if(advancedType === 'array') this.isArray = true;
    
    if(this.isMap && !this.value) this.defaultValue = {};
    if(this.isArray && !this.value) this.defaultValue = [];
  }
  
  // Chainable method for setting required
  setRequired() {
    this.required = true;
    return this;
  }

  setArray(value) {
    this.isArray = true;
    this.defaultValue = value || [];
    return this;
  }

  setMap(value) {
    this.isMap = true;
    this.defaultValue = value || {};
    return this;
  }

  setWysiwyg() {
    this.isWysiwyg = true;
    return this;
  }

  setTextArea() {
    this.isTextArea = true;
    return this;
  }

  setOptions(options) {
    if (typeof options === 'function') {
      options().then((result) => {
        this.options = result;
      });
    } else {
      this.options = options || [];
    }
    return this;
  }

  // Returns the appropriate JavaScript data type for this input
  get dataType() {
    switch(this.type) {
      case 'checkbox': return 'boolean';
      case 'number': return 'number';
      case 'text':
      case 'dropdown': 
        return 'string';
      default:
        return 'string';
    }
  }

  // Method to mark an option as advanced
  setAdvanced(isAdv = true) {
    this.isAdvanced = isAdv;
    return this;
  }
}

export default LayoutInput; 